import React, { useMemo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Link } from 'react-router-dom'
import camelcaseKeys from 'camelcase-keys'
import Skeleton from 'react-loading-skeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faUserCog } from '@fortawesome/free-solid-svg-icons'

import { getUser } from '../../../actions/adminActions'
import DateFormat from '../../utils/dateFormat'

import { AdminHeader } from '../Index'
import Button from '../../utils/Button'
import Header from '../../utils/Header'
import Tabs from '../../utils/Tabs'

import Actions from './Show/Actions'
import ShowDetails from './ShowDetails'
import Requests from './Show/Requests'
import AvailabilityNotifications from '../AvailabilityNotifications/Index'

const tabOptions = [
  { name: 'Requests', value: 'requests' },
  { name: 'Notifications', value: 'notifications' },
  { name: 'Notification Methods', value: 'notificationMethods' },
  { name: 'Payments', value: 'payments' }
]

const AdminUsersIndex = ({ match }) => {
  const dispatch = useDispatch()
  const user = useSelector(store => store.admin.user)
  const [content, setContent] = useState('matches')

  useEffect(() => {
    match.params.id && dispatch(getUser(match.params.id))
  }, [match.params.id])

  return (
    <div>
      <Header header={user.email} subHeader={' '} />

      <ShowDetails />

      <Actions />
      <Tabs options={tabOptions} onChange={setContent} />

      {content === 'requests' && <Requests />}
      {content === 'notifications' && <AvailabilityNotifications short userId={match.params.id} />}
      {content === 'notificationMethods' && (
        <div className="flex flex-wrap mt-6">
          {user.notificationMethods.map(nm => (
            <div key={nm.id} className="flex space-x-4 border-b border-gray-300 hover:bg-gray-100 p-2">
              <div className="flex flex-col flex-grow">
                <div className="text-2xl font-semibold">{nm.param}</div>
                <div className="text-lg text-gray-500">{nm.notificationType}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {content === 'payments' && (
        <div className="flex flex-wrap mt-6">
          {user.payments.map(payment => (
            <div key={payment.id} className="flex space-x-4 border-b border-gray-300 hover:bg-gray-100 p-2">
              <div className="flex flex-col flex-grow">
                <div className="text-2xl font-semibold">${payment.total}</div>
                <div className="text-lg text-gray-500">
                  <DateFormat format="LLL" date={payment.createdAt} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default AdminUsersIndex
